module.exports = __webpack_public_path__ + "img/jibenxinxitubiao.a37f8500.png";